// Keep the exact request recoverable across reloads in this tab. Browser
// localStorage quotas can be exhausted even when sessionStorage is available.
// Never remove another intake's data to make room.
function stores() {
  return ['localStorage', 'sessionStorage'].map(name => {
    try { return globalThis[name]; } catch { return null; }
  });
}
export function readCompletion(key) {
  const records = [];
  for (const storage of stores()) {
    let raw;
    try { raw = storage?.getItem(key); } catch { continue; }
    if (!raw) continue;
    try { records.push(JSON.parse(raw)); } catch { return { expired: true }; }
  }
  if (!records.length) return null;
  // Conflicting snapshots require review, never selection by timestamp.
  if (records.some(record => JSON.stringify(record) !== JSON.stringify(records[0]))) return { expired: true };
  return records[0];
}
export function writeCompletion(key, record) {
  const value = JSON.stringify(record);
  const available = stores();
  for (const storage of available) {
    if (!storage) continue;
    try {
      storage.setItem(key, value);
      if (storage.getItem(key) !== value) continue;
    } catch { continue; }
    // Remove a superseded copy only after a verified successful write.
    for (const other of available) if (other && other !== storage) {
      try { other.removeItem(key); } catch { /* readCompletion detects conflicts */ }
    }
    return;
  }
  throw new Error('Recovery storage unavailable');
}
export function clearCompletion(key) {
  for (const storage of stores()) try { storage?.removeItem(key); } catch { /* confirmed receipt remains authoritative */ }
}
